import { autoserialize } from 'cerialize';

export class TruckMeta {
  @autoserialize isTruckReady: boolean;
  @autoserialize vin?: string | null;

  constructor(payload?: ITruckMeta) {
    this.isTruckReady = !!payload?.isTruckReady;
    this.vin = payload?.vin ?? undefined;
  }
}

export interface ITruckMeta {
  isTruckReady: boolean;
  vin?: string | null;
}
